// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Admin } from './admin';
import { MeetingAttendance } from './meeting-attendance';
import { MeetingResolution } from './meeting-resolution';
import { MeetingType } from './meeting-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Meeting extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  meetingId!: number;
  adjournedToDate?: Date;
  adminId!: number;
  adminTypeId?: number;
  chairperson?: string;
  costsApproved!: number;
  costsFromDate?: Date;
  costsRequested!: number;
  costsToDate?: Date;
  createdBy!: string;
  createdDate!: Date;
  creditorSubClassId?: number;
  date1?: Date;
  date2?: Date;
  date3?: Date;
  dateTimeUtc?: Date;
  feesApproved!: number;
  feesFromDate?: Date;
  feesRequested!: number;
  feesToDate?: Date;
  flags?: number;
  isFinalised!: boolean;
  meetingAddress?: string;
  meetingDate!: Date;
  meetingDescription?: string;
  meetingLocation!: string;
  meetingTime!: Date;
  meetingTypeId!: number;
  memo?: string;
  mergeTemplateId?: number;
  minutesSecretary?: string;
  proxyDueByDate?: Date;
  proxyDueByTime?: Date;
  quorumPresent!: boolean;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  userId?: number;
  webAccessAccountId?: number;
  webAccessFlags?: number;
  webFlags?: number;
  admin!: Admin;
  meetingAttendances!: MeetingAttendance[];
  meetingResolutions!: MeetingResolution[];
  meetingType!: MeetingType;
}

